var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedemptionXpPanel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 306 136.039",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Subtract",
    filter: "url(#filter0_i_0_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306 0L302.466 4.35938L306 8.71777L302.466 13.0771L306 17.4355L302.466 21.7949L305.999 26.1533L302.466 30.5127L306 34.8721L302.466 40.1025L305.999 45.333L302.466 49.6924L306 54.0518L302.466 58.4111L306 62.7695L302.466 67.1289L306 71.4873L302.466 76.7178L305.999 81.9482L302.466 86.3076L305.999 90.666L302.466 95.0254L305.999 99.3838L302.466 103.743L306 108.103L302.466 113.333L305.999 118.563L302.466 122.923L306 127.282L302.466 131.642L306 136V136.039H0V136L3.53418 131.642L0 127.282L3.53418 122.923L0 118.563L3.53418 113.333L0 108.103L3.53418 103.743L0 99.3838L3.53418 95.0254L0 90.666L3.53418 86.3076L0 81.9482L3.53418 76.7178L0 71.4873L3.53418 67.1289L0 62.7695L3.53418 58.4111L0 54.0518L3.53418 49.6924L0 45.333L3.53418 40.1025L0 34.8721L3.53418 30.5127L0 26.1533L3.53418 21.7949L0 17.4355L3.53418 13.0771L0 8.71777L3.53418 4.35938L0 0H306Z",
    fill: "var(--fill-0, #130035)",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_0_4",
    x: 0,
    y: 0,
    width: 306,
    height: 140.039,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_0_4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedemptionXpPanel);
export default __webpack_public_path__ + "static/media/redemption-xp-panel.775dbd0d128ed6de0052f07e7de95451.svg";
export { ForwardRef as ReactComponent };